import useI18n from '@/shared/hooks/usei18n'
import { Button, GenericDialog } from '@/common'
import { Trans } from 'react-i18next'

type CbamSimulationDisclaimerDialogProps = {
  isOpen: boolean
  close: () => void
}

export default function CbamSimulationDisclaimerDialog({
  isOpen,
  close
}: CbamSimulationDisclaimerDialogProps) {
  const { t } = useI18n()

  return (
    <GenericDialog
      isOpen={isOpen}
      close={close}
      title={t('cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.title')}
      subtitle={t('cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.subtitle')}
      size="lg"
      preventCloseOnOutsideClick
    >
      <div className="space-y-4">
        <p className="text-gray-600">
          <Trans
            i18nKey="cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.bodyParagraph1"
            components={{ strong: <strong /> }}
          />
        </p>
        <p className="text-gray-600">
          <Trans
            i18nKey="cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.bodyParagraph2"
            components={{ strong: <strong /> }}
          />
        </p>
        <p className="text-gray-600">
          <Trans
            i18nKey="cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.bodyParagraph3"
            components={{ strong: <strong /> }}
          />
        </p>
        <p className="text-gray-600">
          <Trans
            i18nKey="cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.bodyParagraph4"
            components={{ strong: <strong /> }}
          />
        </p>
        <p className="text-gray-600">
          {t('cbamSimulations:cbamSimulationDetails.dialogs.disclaimer.clickConfirm')}
        </p>
        <div className="flex justify-end pt-4">
          <Button onClick={close}>{t('common:ok')}</Button>
        </div>
      </div>
    </GenericDialog>
  )
}
